import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileReaderService {

  constructor() {
  }

  getFileContent(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        resolve((event.target as FileReader).result);
      };
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }
}


